import { render, staticRenderFns } from "./formWorkOne.vue?vue&type=template&id=aa9225ba&scoped=true"
import script from "./formWorkOne.vue?vue&type=script&lang=js"
export * from "./formWorkOne.vue?vue&type=script&lang=js"
import style0 from "./formWorkOne.vue?vue&type=style&index=0&id=aa9225ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9225ba",
  null
  
)

export default component.exports